import { Events } from './events';

/**
 * Important: In the open() method, we must force the click on Kenect's
 * native button to replicate Kenect's pipeline. If we don't first click its
 * button, form submissions from their iframe form will not have all the desired data
 */

export default class Trigger {
  container;
  kenectButton;

  constructor(containerEl) {
    this.container = containerEl;

    this.attachListeners();
  }

  open() {
    this.kenectButton.click();

    this.container.dataset.activated = true;
    this.container.dispatchEvent(Events.Opened);
  }

  close() {
    this.container.dataset.activated = false;
    this.container.dispatchEvent(Events.Closed);
  }

  toggle() {
    if (this.isOpen) {
      this.close();
      return;
    }

    this.open();
  }

  on(event, callback) {
    this.container.addEventListener(event, callback);
  }

  enable() {
    this.container.ariaDisabled = false;
  }

  disable() {
    this.container.ariaDisabled = true;
  }

  setKenectButton(kenectButtonEl) {
    this.kenectButton = kenectButtonEl;
  }

  get enabled() {
    return this.container.ariaDisabled === 'false';
  }

  get isOpen() {
    return this.container.dataset.activated === 'true';
  }

  attachListeners() {
    this.container.addEventListener('click', () => {
      if (!this.enabled) return;

      this.toggle();
    });
  }
}
